import { useCallback, useState } from "react";

const useToggleRows = () => {
  const [toggledRows, setToggledRows] = useState<string[]>([]);

  const toggleRow = useCallback((id: string) => {
    setToggledRows((_toggledRows) => {
      const index = _toggledRows.indexOf(id);
      return index < 0
        ? [..._toggledRows, id]
        : [..._toggledRows.slice(0, index), ..._toggledRows.slice(index + 1)];
    });
  }, []);

  // Explicitly remove
  const unToggleRow = useCallback((id: string) => {
    setToggledRows((_toggledRows) => {
      const index = _toggledRows.indexOf(id);
      return index < 0
        ? _toggledRows
        : [..._toggledRows.slice(0, index), ..._toggledRows.slice(index + 1)];
    });
  }, []);

  const clearRows = useCallback(() => {
    setToggledRows([]);
  }, []);

  return { toggleRow, unToggleRow, toggledRows, clearRows };
};

export default useToggleRows;
